// extracted by mini-css-extract-plugin
module.exports = {"container":"Services-module--container--2fWMm"};